module.exports = __webpack_public_path__ + "static/img/illustratepic_02.8ef7b7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ko/illustratepic_02.png
// module id = MaIN
// module chunks = 1